if (!customElements.get('grouped-products')) {
  class GroupedProducts extends HTMLElement {
    constructor() {
      super();

      // Selectors
      this.thumbs = this.querySelectorAll('[data-thumb]');
      this.label = this.querySelector('[data-color-name]');
      this.showMore = this.querySelector('[data-show-more]');

      // Event listeners
      this.thumbs.forEach((thumb) => {
        thumb.addEventListener('mouseenter', (event) => {
          if (document.querySelector('html').classList.contains('touch')) {
            return;
          }
          // Get the target
          const target = event.currentTarget || event.target;
          if (!target) {
            return false;
          }
          this.updateLabel(target);
          this.showTooltip(target);
        });

        thumb.addEventListener('mouseleave', (event) => {
          if (document.querySelector('html').classList.contains('touch')) {
            return;
          }
          // Get the target
          const target = event.currentTarget || event.target;
          if (!target) {
            return false;
          }
          this.resetLabel();
          this.hideTooltip(target);
        });
      });

      this.showMore &&
        this.showMore.addEventListener('click', (event) => {
          event.preventDefault();
          this.showMoreThumbs();
        });
    }

    /**
     * Show tooltip
     * @param {object} target
     */
    showTooltip(target) {
      if (!target) return false;

      // Check if the tooltip not is already visible
      const tooltip = target.querySelector('.tooltip');
      if (tooltip) {
        return false;
      }

      // Get the image
      const image = target.dataset.image;
      if (!image) {
        return false;
      }

      // Get the title
      const title = target.dataset.thumb || '';

      const html = `
        <div class="tooltip absolute left-1/2 -translate-x-1/2 w-12 h-12 -top-14 border-[0.188rem] border-white rounded-xl bg-white">
          <img src="${image}" alt="${title}" loading="eager" width="42" height="42" class="aspect-square w-14 overflow-hidden rounded-xl object-cover">
          <span class="absolute top-full left-1/2 -translate-x-1/2 border-l-8 border-l-transparent border-t-8 border-t-white border-r-8 border-r-transparent"></span>
        </div>
      `;
      const DOM = new DOMParser().parseFromString(html, 'text/html').querySelector('.tooltip');

      target.appendChild(DOM);
    }

    /**
     * Hide tooltip
     * @param {object} target
     */
    hideTooltip(target) {
      if (!target) return false;

      // Check if there is a tooltip to remove
      const tooltip = target.querySelector('.tooltip');
      if (!tooltip) {
        return false;
      }

      // Remove the tooltip
      tooltip.remove();
    }

    /**
     * Update label
     * @param {object} target
     */
    updateLabel(target) {
      if (!target || !this.label) return false;

      // Update title
      this.label.innerHTML = target.dataset.thumb || '';
    }

    /**
     * Reset label to default
     */
    resetLabel() {
      if (!this.label) return false;

      // Update title
      this.label.innerHTML = this.label.dataset.colorName || '';
    }

    /**
     * Show more thumbs and remove the show more button
     */
    showMoreThumbs() {
      this.thumbs.forEach((thumb) => {
        thumb.closest('li').classList.remove('hidden');
      });
      this.showMore.remove();
    }
  }

  window.GroupedProducts = GroupedProducts;

  customElements.define('grouped-products', GroupedProducts);
}
